import React from "react";
import { INPUT_CLASS, LABEL_CLASS } from "../constants";

interface DateInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (date: string) => void;
}

const DateInput: React.FC<DateInputProps> = ({
  id,
  label,
  value,
  onChange,
}) => {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <label htmlFor={id} className={LABEL_CLASS}>
        {label}:
      </label>
      <input
        id={id}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={INPUT_CLASS}
      />
    </div>
  );
};

export default DateInput;
